
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Search } from 'react-bootstrap-icons';

import React, { useState, useEffect } from 'react';

import StoreItem from '../modules/CardStoreItem';
import RangeSlider from "../blocks/xxxRangeSlider";


/** Expiremental Imports */

import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import { GetHeaders, PostDataFetch } from "../../hooks/DataFetch";
import { INTRFItem } from '../../hooks/Interfaces';

interface ApplicationProps {
    category_limit?: string;
    updatefunc: () => void;
}
/*
interface ItemProps {
    inventory_id: string;
    name: string;
    image_url: string
    category: string;
    group: string;
    subgroup: string;
    price: number;
    rating: number;
    size: number;
    image: string;
    abv: number;
    description: string;
}*/

function InventoryList({category_limit = "", updatefunc}: ApplicationProps) {

    /* For UI  */
    const [inventory, setInventory] = useState<INTRFItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [searched, setSearched] = useState(false);

    /* For UI API */
    const [categories, setCategories] = useState(['']);
    const [target_category, setTargetCategory] = useState(category_limit);
    const [tags, setTags] = useState(['']);
    const [search_string, setSearchString] = useState('');
    const [min_price, setMinPrice] = useState(0.00);
    const [max_price, setMaxPrice] = useState(200);
    const [min_rating, setMinRating] = useState(0);//No Longer Implemented in UI
    const [max_rating, setMaxRating] = useState(5);//No Longer Implemented in UI
    
    /** Config */
    let axiosConfig = GetHeaders();
    const posturl = process.env.REACT_APP_API_URL + "/v1/catalogue/inventory";

    const filterinfo = {
        categories,
        tags,
        search_string,
        min_price,
        max_price,
        min_rating,
        max_rating,
        target_category,
    };

    const priceChange = (event: any) => {
        setMinPrice(event[0]);
        setMaxPrice(event[1]);
    };

    const ratingChange = (event: any) => {
        setMinRating(Number(event[0]));
        setMaxRating(Number(event[1]));
    };


   
    /* Component Init */
    useEffect(() => {
        if (inventory.length < 1){
            GetInventory();
        }
        
    }, [inventory]);

    const GetInventory = async () => {
        setLoading(true);
        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: filterinfo})
        //Handle a Non 200 response
        setInventory(response.items)
        setLoading(false);
        setSearched(true);
    }
    
    const handleSubmit = async (event: React.SubmitEvent) => {
        event.preventDefault();
        GetInventory();
    }



    return (
        <>
        <Row>
            <Col md={{ span: 3 }} className="">
                <Container className="border rounded py-3 px-4 mt-2">
                    <form onSubmit={handleSubmit}>
                        <label className="form-label text-font-size-small text-font-body">Search Inventory</label>
                        <Row className="brand-tertiary-color-border-full rounded-pill py-2">
                            <Col xs={{ span: 10 }} className="p-0 ps-1 pb-1">
                                <input id="search_string" type="text" placeholder="Search" className="input-fill border-0 no-generic-input-styles" onChange={(e) => {setSearchString(e.target.value)}} />
                            </Col>
                            <Col xs={{ span: 2 }}>
                                <Search className="text-font-size-medium" />
                            </Col>
                        </Row>

                        <Row className="my-4 px-1">
                            <label className="form-label text-font-size-small text-font-body">Price Range: ${min_price} - ${max_price}</label>
                            <Nouislider range={{ min: 0, max: 200}} start={[min_price, max_price]} step={5} connect onSlide={priceChange} />
                        </Row>
                        <button type="submit"  className="btn brand-btn-secondary-color input-fill">Go</button>
                    </form>
                </Container>
            </Col>
            <Col md={{ span: 9 }}>
                <Row>{
                inventory.map( (item, index)  => 
                    <Col key={item.itemid} md={{ span: 3 }} className="p-2">
                        <StoreItem 
                            item={item} 
                            appupdate={updatefunc}
                        />
                    </Col>)
                }</Row>
                { (inventory.length < 1) && searched &&
                    <Row>
                        <Col>
                        <p className="text-font-size-large text-font-body text-font-heavy">No results..</p>
                        </Col>
                    </Row>
                
                }
                
            </Col>
        </Row>
        </>
    )
}

export default InventoryList;